module.exports = __webpack_public_path__ + "img/facts-all_1961.b54f51d2.png";